
const theNav = document.querySelector('.s-header__nav')
const navHamburger = document.querySelector('#s-header__hamburger');
const navCross = document.querySelector('#s-header__cross');
const navWrapper = document.querySelector('#b-nav-wrapper')
const headerWrapper = document.querySelector('#s-header-wrapper')
const fakeHeaderWrapper = document.querySelector('#s-fake-header-wrapper')
const body = document.querySelector('body')
const subMenus = document.querySelectorAll('.b-nav-submenu')
const navSearchBtn = document.querySelector('.s-header__search')
const navSearchBtnClose = document.querySelector('.s-header__search-close')
const searchBlock = document.querySelector('.s-search-wrapper')

const itsTheSearchResultsPage = document.querySelector('.s-listings-wrapper--search-results')

if (theNav) {
  if (navHamburger) {
    navHamburger.addEventListener('click', () => {

      headerWrapper.classList.add('s-header-wrapper--fixed')
      fakeHeaderWrapper.classList.add('s-fake-header-wrapper--show')

      navWrapper.classList.remove("b-nav-wrapper--hide")
      navWrapper.classList.add("b-nav-wrapper--show")

      navHamburger.classList.remove('s-header__nav-button--show')
      navHamburger.classList.add('s-header__nav-button--hide')
      navCross.classList.remove('s-header__nav-button--hide')
      navCross.classList.add('s-header__nav-button--show')

      body.classList.add('hide-scrollbars')

      // hide search
      navSearchBtn.classList.remove('s-header__search-button--show')
      navSearchBtn.classList.add('s-header__search-button--hide')

    })
  }

  navCross.addEventListener('click', () => {

    headerWrapper.classList.remove('s-header-wrapper--fixed')
    fakeHeaderWrapper.classList.remove('s-fake-header-wrapper--show')

    navWrapper.classList.remove("b-nav-wrapper--show")
    navWrapper.classList.add("b-nav-wrapper--hide")

    navHamburger.classList.remove('s-header__nav-button--hide')
    navHamburger.classList.add('s-header__nav-button--show')
    navCross.classList.remove('s-header__nav-button--show')
    navCross.classList.add('s-header__nav-button--hide')

    body.classList.remove('hide-scrollbars')

    subMenus.forEach(subMenu => {
      subMenu.classList.remove('b-nav-submenu--show');
    });

    body.style.cssText = 'position: static'
    level1_lis.forEach(element => {
      element.classList.remove('active')
    });

    // show search

    if (!itsTheSearchResultsPage) {
      navSearchBtn.classList.remove('s-header__search-button--hide')
      navSearchBtn.classList.add('s-header__search-button--show')
    }
  })

  // search --- search --- search ---

  if (itsTheSearchResultsPage) {
    navSearchBtn.classList.add('s-header__search-button--hide')
  } else {
    navSearchBtn.classList.remove('s-header__search-button--show')
  }

  navSearchBtn.addEventListener('click', () => {
    // buttons
    navSearchBtn.classList.remove('s-header__search-button--show')
    navSearchBtn.classList.add('s-header__search-button--hide')
    navSearchBtnClose.classList.remove('s-header__search-button--hide')
    navSearchBtnClose.classList.add('s-header__search-button--show')
    navHamburger.classList.remove('s-header__nav-button--show')
    navHamburger.classList.add('s-header__nav-button--hide')

    // show search block

    searchBlock.classList.remove('s-search-wrapper--hide')
    searchBlock.classList.add('s-search-wrapper--show')

    headerWrapper.classList.add('s-header-wrapper--fixed')
    fakeHeaderWrapper.classList.add('s-fake-header-wrapper--show')

    body.classList.add('hide-scrollbars')
    body.style.cssText = 'position: fixed; width: 100%;'
    navWrapper.style = "display: none"
  })

  navSearchBtnClose.addEventListener('click', () => {
    navSearchBtnClose.classList.remove('s-header__search-button--show')
    navSearchBtnClose.classList.add('s-header__search-button--hide')

    navSearchBtn.classList.remove('s-header__search-button--hide')
    navSearchBtn.classList.add('s-header__search-button--show')

    navHamburger.classList.remove('s-header__nav-button--hide')
    navHamburger.classList.add('s-header__nav-button--show')

    searchBlock.classList.remove('s-search-wrapper--show')
    searchBlock.classList.add('s-search-wrapper--hide')

    headerWrapper.classList.remove('s-header-wrapper--fixed')
    fakeHeaderWrapper.classList.remove('s-fake-header-wrapper--show')
    body.classList.remove('hide-scrollbars')
    navWrapper.style = "display: block"
    body.style.cssText = 'position: unset'

  })
}
